import { Component } from '@angular/core';
import { soundpostRevenueRecognitionRuleEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Revenue Recognition Rules') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostrevenuerecognitionrule-form',
    templateUrl: './soundpostrevenuerecognitionrule.form.component.html'
})
export class soundpostRevenueRecognitionRuleFormComponent extends BaseFormComponent {
    public record!: soundpostRevenueRecognitionRuleEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

